import { basicJSONDELETE, basicJSONPOST } from "../../api/fetchHelpers";

export async function emailLead(id, email, endpoint, token) {
    const response = await fetch(endpoint+"send/"+id+"/"+email, basicJSONPOST());
    if (!response.ok) {
        const message = 'An error has occured: '+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}

export async function deleteWorkflowEvent(id, endpoint, token) {
    const response = await fetch(endpoint+"status/"+id, basicJSONDELETE());
    if (!response.ok) {
        const message = 'An error has occured: '+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}